import PropTypes from 'prop-types';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const BooleanPreview = ({ value }) => {
  const { t } = useTranslation('common');
  return value ? t('yes') : t('no');
};

export default memo(BooleanPreview);

BooleanPreview.propTypes = {
  value: PropTypes.bool
};
